import { footerLinks } from "@/mocks/home";

const socials = [
  { icon: "ri-wechat-line", label: "微信" },
  { icon: "ri-weibo-line", label: "微博" },
  { icon: "ri-mail-line", label: "邮箱" },
  { icon: "ri-rss-line", label: "订阅" },
];

export default function SiteFooter() {
  return (
    <footer className="bg-secondary-950">
      <div className="px-4 py-12 md:px-10 md:py-14">
        <div className="flex flex-col gap-10 lg:flex-row lg:justify-between">
          <div className="max-w-sm">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-accent-950">
                <i className="ri-movie-2-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-semibold text-background-50">
                迷人的保姆
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-300">
              面向想找迷人的保姆视频资源的观众，汇集电影、短片与完整版内容入口，并配备中文字幕方便理解剧情。
            </p>
            <div className="mt-5 flex gap-2.5">
              {socials.map((s) => (
                <span
                  key={s.label}
                  aria-label={s.label}
                  className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-50/15 text-background-200 transition-colors hover:border-accent-500 hover:text-accent-400"
                >
                  <i className={`${s.icon} text-base`}></i>
                </span>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-x-8 gap-y-8 sm:grid-cols-4 lg:gap-x-14">
            {footerLinks.map((col) => (
              <div key={col.title}>
                <h4 className="font-heading text-sm font-semibold text-background-50">
                  {col.title}
                </h4>
                <ul className="mt-4 space-y-2.5">
                  {col.items.map((item) => (
                    <li key={item}>
                      <a
                        href="#top"
                        className="whitespace-nowrap text-sm text-background-300 transition-colors hover:text-accent-400"
                      >
                        {item}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-50/10 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-background-400">
            © 2026 迷人的保姆 · 内容聚合导航，本站仅提供资源索引与字幕说明
          </p>
          <p className="text-xs text-background-400">
            影片、短片与中文字幕版本信息以页面标注为准
          </p>
        </div>
      </div>
    </footer>
  );
}